import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	// Section 1
	valueProp1Title: {
		id: 'project-template-select-v2.utils.templates.product-discovery.product-roadmap.value-prop-1-title',
		defaultMessage: 'Easily share info with anyone',
		description: 'Title for section that summarizes the value of this template',
	},
	valueProp1Description: {
		id: 'project-template-select-v2.utils.templates.product-discovery.product-roadmap.value-prop-1-description',
		defaultMessage:
			'Create and share custom roadmaps with different stakeholders - even your customers.',
		description: 'Description for section that explains more details about the value of template',
	},
	// Section 2
	valueProp2Title: {
		id: 'project-template-select-v2.utils.templates.product-discovery.product-roadmap.value-prop-2-title',
		defaultMessage: 'Keep your team engaged',
		description: 'Title for section that summarizes the value of this template',
	},
	valueProp2Description: {
		id: 'project-template-select-v2.utils.templates.product-discovery.product-roadmap.value-prop-2-description',
		defaultMessage:
			'Get everyone involved in building your roadmap using comments, reactions, and votes.',
		description: 'Description for section that explains more details about the value of template',
	},
	// Section 3
	valueProp3Title: {
		id: 'project-template-select-v2.utils.templates.product-discovery.product-roadmap.value-prop-3-title',
		defaultMessage: 'See progress, without tool-switching',
		description: 'Title for section that summarizes the value of this template',
	},
	valueProp3DescriptionSpork: {
		id: 'project-template-select-v2.utils.templates.product-discovery.product-roadmap.value-prop-3-description-spork',
		defaultMessage:
			'Track progress to delivery by linking ideas to Jira issues for a seamless workflow.',
		description: 'Description for section that explains more details about the value of template',
	},
	recommendedList1: {
		id: 'project-template-select-v2.utils.templates.product-discovery.product-roadmap.recommended-list-1',
		defaultMessage: 'Teams that need to create and share roadmaps',
		description: 'Recommended project types to use this template',
	},
	valueProp3DescriptionSporkIssueTermRefresh: {
		id: 'project-template-select-v2.utils.templates.product-discovery.product-roadmap.value-prop-3-description-spork-issue-term-refresh',
		defaultMessage:
			'Track progress to delivery by linking ideas to Jira work items for a seamless workflow.',
		description: 'Description for section that explains more details about the value of template',
	},
});
